import { render, staticRenderFns } from "./TreeNodeFileTable.global.vue?vue&type=template&id=5847ac50&scoped=true&lang=pug&"
import script from "./TreeNodeFileTable.global.vue?vue&type=script&lang=ts&"
export * from "./TreeNodeFileTable.global.vue?vue&type=script&lang=ts&"
import style0 from "./TreeNodeFileTable.global.vue?vue&type=style&index=0&id=5847ac50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5847ac50",
  null
  
)

export default component.exports